//引入axios 
import request from '../utils/request'// 这里是引入咱们的axios用axios来进行异步接口请求
//比如说接口为注册接口
export function userLogin(data){
    return request({
        url:'/api/user/login',
        method:'post',
        data,  
    })
}

export function userWxLogin(data){
    return request({
        url:'/api/user/wxlogin',
        method:'post',
        data,  
    })
}